module.exports = __webpack_public_path__ + "static/media/model.9a676317.png";